const {get_header_height} = require('../helpers/_utils');

module.exports = function init_anchor() {

  function adjust_beaver_builder_offset() {
      if (typeof FLBuilderLayoutConfig !== "undefined") {
          const header_height = get_header_height();
          FLBuilderLayoutConfig.anchorLinkAnimations.offset = header_height;
      }
  }

  function scroll_to_anchor(anchor_id) {
      const target_element = document.getElementById(anchor_id);
      if (target_element) {
          const header_height = get_header_height();
          const element_position = target_element.getBoundingClientRect().top + window.scrollY;
          const offset_position = element_position - header_height;

          window.scrollTo({
              top: offset_position,
              behavior: 'smooth'
          });
      }
  }

  function handle_anchor_click(e) {
      const anchor = e.target.closest('a[href^="#"]');
      if (anchor) {
          e.preventDefault();
          const anchor_id = anchor.getAttribute('href').substring(1);
          scroll_to_anchor(anchor_id);
      }
  }

  function handle_initial_hash() {
      if (window.location.hash) {
          const anchor_id = window.location.hash.substring(1);
          // Delay scrolling slightly to ensure page is fully loaded
          setTimeout(() => scroll_to_anchor(anchor_id), 100);
      }
  }

  // Adjust Beaver Builder offset as soon as possible
  adjust_beaver_builder_offset();

  // Set up click event listener for anchor links
  document.body.addEventListener('click', handle_anchor_click);

  // Handle initial hash on page load
  window.addEventListener('load', handle_initial_hash);

  // Re-adjust Beaver Builder offset if the window is resized (in case header height changes)
  window.addEventListener('resize', adjust_beaver_builder_offset);

  // Handle hash changes (e.g., when using browser back/forward buttons)
  window.addEventListener('hashchange', () => {
      if (window.location.hash) {
          const anchor_id = window.location.hash.substring(1);
          scroll_to_anchor(anchor_id);
      }
  });
}

